import { SaasFooter, SaasNav } from "../components/saas-shell.js";
import { Traction } from "../components/traction.js";

/**
 * The public metrics page. It is the same band the landing carries, given a
 * URL of its own so it can be linked to and sent to someone directly — the
 * landing shows it in passing, this is where you point a person.
 *
 * Every figure comes from `components/traction.tsx`, and every figure there is
 * fabricated placeholder copy. See that file's header.
 *
 * Not to be confused with /stats, which is the signed-in, per-account rollup
 * built from real Iceberg data.
 */

export function Metrics() {
  return (
    <div className="landing saas">
      <SaasNav />
      <Traction level={1} />
      <SaasFooter />
    </div>
  );
}
